import {SubAPI} from "./SubAPI";

export class UserPreferences extends SubAPI {

    list(input: {}) {
        return this.fetcher.get<UserPreference[]>("/api/user-preferences", input)
    }

    upsert(input: {
        key: string;
        value: string;
        archived?: boolean;
    }) {
        return this.fetcher.post("/api/user-preference", input);
    }
}

export type UserPreference = {
    key: string;
    value: string;
}
